import Select from "common/components/Select/Select";
import { useTranslation } from "react-i18next";
import { Language } from "types/Language";
import { BR, DE, ES, FR, GB } from "country-flag-icons/react/3x2";
import { useMemo } from "react";

const handleLanguageChange = () => {};
type LanguageOption = {
  value: Language;
  name: string;
  flag: JSX.Element;
};
function LangageSelect(props: any) {
  const { t } = useTranslation();

  const languageOptions: LanguageOption[] = useMemo(
    () => [
      {
        value: "en",
        name: t("language.en"),
        flag: <GB className="h-[1em]" />,
      },
      {
        value: "fr",
        name: t("language.fr"),
        flag: <FR className="h-[1em]" />,
      },
      {
        value: "de",
        name: t("language.de"),
        flag: <DE className="h-[1em]" />,
      },
      {
        value: "es",
        name: t("language.es"),
        flag: <ES className="h-[1em]" />,
      },
      {
        value: "pt-BR",
        name: t("language.pt"),
        flag: <BR className="h-[1em]" />,
      },
    ],
    [t]
  );
  return (
    <Select
      clearable={false}
      onChange={handleLanguageChange}
      options={languageOptions
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((language) => {
          return {
            label: (
              <div className="flex items-center gap-2">
                {language.flag}
                <p>{language.name}</p>
              </div>
            ),
            value: language.value,
          };
        })}
      {...props}
    />
  );
}

export default LangageSelect;
